/*
tslint:disable:import-spacing no-inferrable-types
variable-name align no-trailing-whitespace component-class-suffix
no-string-literal component-selector
*/

import  'ag-grid-enterprise';

import { PeriodEditor }     from '@/helpers/period.editor';


import {ICellEditorParams} from "ag-grid-community";

/**
 *
 * @class DurationEditor
 *
 * @brief variation of period editor, limited to 24 hours.
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      June 2020
 *
 */
export class DurationEditor extends PeriodEditor {


  /** setup the custom editor (happens on every edit attempt) */
  public init(params: ICellEditorParams): void {

    /* configure for 24 hours only */

    this.noDays = true;

    super.init(params);
  }

}
